import { all, includes, keys, pickAll } from 'ramda';
import { isNilOrEmpty } from 'ramda-extension';

import { toIsoDateFormat } from 'utils';

import { requiredFields } from './constants';

export const requestFactory = (formData) => {
	const filter = [];

	keys(formData).forEach((key) => {
		let value;
		const data = formData[key];

		if (!isNilOrEmpty(data)) {
			if (Array.isArray(data)) {
				value = [...data];
			} else {
				value = [data];
			}

			const isCreatedDateInput = includes(key, ['createdFrom', 'createdTo']);

			if (isCreatedDateInput) {
				if (key === 'createdFrom') {
					filter.push({
						operation: 'notLessThan',
						property: 'createDate',
						value: value.map((v) => toIsoDateFormat(v)),
					});
				} else {
					filter.push({
						operation: 'notGreaterThan',
						property: 'createDate',
						value: value.map((v) => toIsoDateFormat(v)),
					});
				}
			} else {
				filter.push({
					operation: 'equal',
					property: key,
					value: value.map((v) => v.toString()),
				});
			}
		}
	});

	return { filter, searchInAllTasks: true, ignoreTasksLimit: false };
};

export const noneOfRequiredFieldsFilled = (formData) => {
	const requiredFormFields = pickAll(requiredFields, formData);
	const values = Object.values(requiredFormFields);
	return all(isNilOrEmpty)(values);
};
